// extracted by mini-css-extract-plugin
module.exports = {"visualitzacioSelector":"VisualitzacioSelectorEspecie_visualitzacioSelector__OzvCv","Select":"VisualitzacioSelectorEspecie_Select__1ea5M"};